/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { PCState } from '../../../core/enums';
import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import {
    SET_PC_MENU_OPTIONS,
    SET_PC_SETTING_VERTICAL_LIMIT,
    SET_PC_SETTINGS_HIGHLIGHT_POSITION,
    SET_PC_STATE,
} from './parentalcontrols.types';

export const setPCSettingVerticalLimitAction = (
    verticalLimit: number,
): TivoPayloadAction<{
    verticalLimit: number;
}> => ({
    type: SET_PC_SETTING_VERTICAL_LIMIT,
    payload: {
        verticalLimit,
    },
});

export const setPCStateAction = (pcState: PCState): TivoPayloadAction<{ pcState: PCState }> => ({
    type: SET_PC_STATE,
    payload: { pcState },
});

export const setPCMenuOptionsAction = (
    menuOptions: Array<any>,
): TivoPayloadAction<{ menuOptions: Array<any> }> => ({
    type: SET_PC_MENU_OPTIONS,
    payload: {
        menuOptions,
    },
});

export const setPCSettingsFocusedPositionAction = (
    verticalPosition: number,
    isFocused: boolean,
): TivoPayloadAction<{
    verticalPosition: number;
    isFocused: boolean;
}> => ({
    type: SET_PC_SETTINGS_HIGHLIGHT_POSITION,
    payload: {
        verticalPosition,
        isFocused,
    },
});
